import React, { useState } from 'react';
import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';

import { getMolForStructure } from '../GSFNService';
import GSFNDialog from './GSFNDialog';

export function GSFNDialogContainer({ onStructureLoaded, selfClose, options, notFoundInfoMessage, notFoundMessage }) {
  // store request in state, if it is WS it has 'cancel' method which needs to be called on self close
  const [activeRequest, setActiveRequest] = useState(null);
  const [substances, setSubstances] = useState(null);
  const [errorText, setErrorText] = useState('');

  const selfCloseHandler = () => {
    if (activeRequest) {
      // cancel request in case on WS
      if (isFunction(activeRequest?.cancel)) activeRequest.cancel();
      setActiveRequest(null);
    }
    selfClose();
  };

  const onSubstanceSelectHandler = (substance) => {
    selfClose();
    onStructureLoaded(substance.structure);
  };

  const onInputEnterHandler = (textQuery, optionValue) => {
    // Prevent multi trigger
    if (activeRequest) {
      return;
    }

    setSubstances(null);
    setErrorText('');

    const request = getMolForStructure(textQuery, optionValue)
      .then(({ substances: fetchedSubstances }) => {
        if (!fetchedSubstances?.length) {
          setErrorText(notFoundMessage);
        } else if (fetchedSubstances.length === 1) {
          onSubstanceSelectHandler(fetchedSubstances[0]);
        } else {
          setSubstances(fetchedSubstances);
        }
        setActiveRequest(null);
      })
      .catch((error) => {
        Logger.error(error);
        setActiveRequest(null);
      });

    setActiveRequest(request);
  };

  return (
    <GSFNDialog
      selfClose={selfCloseHandler}
      errorInfoMessage={notFoundInfoMessage}
      errorText={errorText}
      options={options}
      onInputEnter={onInputEnterHandler}
      isLoading={!!activeRequest}
      substances={substances}
      onSubstanceSelect={onSubstanceSelectHandler}
    />
  );
}

GSFNDialogContainer.propTypes = {
  onStructureLoaded: PropTypes.func.isRequired,
  selfClose: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      isDisabled: PropTypes.bool,
    })
  ).isRequired,
  notFoundInfoMessage: PropTypes.string,
  notFoundMessage: PropTypes.string,
};

export default GSFNDialogContainer;
